import { Inject, Injectable } from '@angular/core';

import { APP_ENVIRONMENT, AppEnvironment } from '@shure/cloud/shared/utils/config';
import { asLabel } from '@shure/shared/models';

import { ApplicationType, NavigationItems } from '../../..';

@Injectable({ providedIn: 'root' })
export class SideNavItemProvider {
	constructor(@Inject(APP_ENVIRONMENT) private readonly appEnv: AppEnvironment) {}

	public getItems(): NavigationItems[] {
		return [
			{
				icon: 'home',
				label: asLabel('cloud.shure-cloud.home'),
				disabled: false,
				route: 'home',
				labelId: 'home',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			},
			{
				icon: 'apps',
				label: asLabel('cloud.shure-cloud.apps'),
				disabled: false,
				route: 'apps',
				labelId: 'apps',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			},
			{
				icon: 'sh-devices',
				label: asLabel('cloud.shure-cloud.devices'),
				disabled: false,
				route: 'devices',
				labelId: 'devices',
				selected: false,
				applicationType: ApplicationType.CloudDeviceManagement,
				permission: 'viewDeviceManagement',
				// Not all of CDM's secondary routes are nested under a common base route, so we can't use route matching
				// to determine if the primary nav item is active. Instead, we can just check that we are currently
				// running in the CDM application.
				checkActive: (): boolean => {
					return this.appEnv.application === ApplicationType.CloudDeviceManagement;
				}
			},
			{
				icon: 'sh-license',
				label: asLabel('cloud.shure-cloud.license-management.licenses-and-warranties'),
				disabled: false,
				route: 'licenses',
				labelId: 'licenses',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			},
			{
				icon: 'group',
				label: asLabel('cloud.shure-cloud.users.users'),
				disabled: false,
				route: 'user-management',
				labelId: 'users',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			},
			{
				icon: 'group',
				label: asLabel('cloud.shure-cloud.roles.roles'),
				disabled: false,
				route: 'roles',
				labelId: 'roles',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			},
			{
				icon: 'sh-eventlog',
				label: asLabel('cloud.shure-cloud.event-log.event-log'),
				disabled: false,
				route: 'event-log',
				labelId: 'event',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			},
			{
				icon: 'settings',
				label: asLabel('cloud.shure-cloud.org-settings.organization-settings'),
				disabled: false,
				route: 'organization-settings',
				labelId: 'org-settings',
				selected: false,
				applicationType: ApplicationType.OrganizationPortal
			}
		];
	}
}
